import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { BufferGeometry, Float32BufferAttribute, LineBasicMaterial } from 'three';
import { resolveConnectorOrbitEndpoints } from '../_pure/connectorOrbit.js';
import { areRenderPropsValueEqual } from '../_pure/valueEquality.js';
export const OrbitingConnectorLine = memo(function OrbitingConnectorLine(props) {
    const geometry = useMemo(() => new BufferGeometry().setAttribute('position', new Float32BufferAttribute([...props.start, ...props.end], 3)), [props.start, props.end]);
    const material = useMemo(() => new LineBasicMaterial({
        color: props.color, opacity: props.opacity, transparent: props.opacity < 1, depthTest: props.depthTest,
    }), [props.color, props.opacity, props.depthTest]);
    useFrame(() => {
        const seconds = props.readCueElapsed?.(props.orbit.afterCue);
        const { start, end } = resolveConnectorOrbitEndpoints(props.start, props.end, props.orbit, seconds ?? 0);
        const positions = geometry.getAttribute('position');
        positions.setXYZ(0, ...start);
        positions.setXYZ(1, ...end);
        positions.needsUpdate = true;
    });
    useEffect(() => () => geometry.dispose(), [geometry]);
    useEffect(() => () => material.dispose(), [material]);
    return _jsx("lineSegments", { geometry: geometry, material: material, frustumCulled: false, dispose: null });
}, areRenderPropsValueEqual);
